
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/86f7edde27ed36b0cdb9d4590def9273.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span className="block" style={{ fontFamily: '"Pacifico", serif' }}>Licores Don Juan</span>
            <span className="block text-red-500">Entrega Rápida</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-2xl mx-auto">
            La mejor selección de licores, vinos y cervezas entregados en toda Bogotá. 
            Servicio 24/7 con entrega en 30-45 minutos.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg"
              onClick={() => scrollToSection('pedidos')}
              className="text-lg px-10 py-4"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-shopping-cart-fill"></i>
              </div>
              Hacer Pedido Ahora
            </Button>
            <Button 
              variant="outline"
              size="lg"
              onClick={() => scrollToSection('productos')}
              className="text-lg px-10 py-4 border-white text-white hover:bg-white hover:text-gray-900"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-eye-fill"></i>
              </div>
              Ver Productos
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-fill text-3xl text-red-500"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Servicio 24/7</h3>
              <p className="text-gray-300">Disponibles las 24 horas del día</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-fill text-3xl text-red-500"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Entrega Rápida</h3>
              <p className="text-gray-300">En 30-45 minutos a tu puerta</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-fill text-3xl text-red-500"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Toda Bogotá</h3>
              <p className="text-gray-300">Cobertura en toda la ciudad</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
